import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section-toggle section-toggle--form" }
const _hoisted_2 = {
  key: 0,
  class: "sections-list"
}
const _hoisted_3 = { class: "section-info" }
const _hoisted_4 = { class: "section-title-row" }
const _hoisted_5 = { class: "section-key" }
const _hoisted_6 = { class: "section-role" }
const _hoisted_7 = { class: "section-controls" }
const _hoisted_8 = { class: "section-toggle" }
const _hoisted_9 = { class: "section-actions" }
const _hoisted_10 = {
  key: 1,
  class: "empty-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Разделы медиатеки",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Добавить подраздел медиатеки", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select, {
                        label: "Главный раздел",
                        "label-placement": "stacked",
                        modelValue: _ctx.selectedMediaCategory,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMediaCategory) = $event)),
                        interface: "popover",
                        mode: "ios",
                        placeholder: "Выберите раздел",
                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMediaCategoryChange()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaCategories, (category) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: category.key,
                              value: category.key
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(category.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Название (для пользователей)",
                        "label-placement": "stacked",
                        modelValue: _ctx.newSection.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newSection.name) = $event)),
                        placeholder: "Например: Академия"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("label", _hoisted_1, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "Доступно всем", -1)),
                    _createVNode(_component_ion_toggle, {
                      modelValue: _ctx.newSection.availableToAll,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newSection.availableToAll) = $event)),
                      mode: "ios"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_ion_item, {
                    class: _normalizeClass(['section-role-select', { 'section-role-select--disabled': _ctx.newSection.availableToAll }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select, {
                        label: "Роль доступа",
                        "label-placement": "stacked",
                        modelValue: _ctx.newSection.roleName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newSection.roleName) = $event)),
                        interface: "popover",
                        "interface-options": _ctx.roleSelectPopoverOptions,
                        mode: "ios",
                        placeholder: "Выберите роль",
                        disabled: _ctx.newSection.availableToAll
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: a.name,
                              value: a.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(a.description || a.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "interface-options", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Ключ папки (латиница)",
                        "label-placement": "stacked",
                        modelValue: _ctx.newSection.folderKey,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newSection.folderKey) = $event)),
                        placeholder: "Academia, CoachGP, Ted"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addSection())),
                    disabled: !_ctx.canAddSection
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Добавить подраздел", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Список подразделов: " + _toDisplayString(_ctx.mediaCategoryTitle), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (_ctx.sections.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s.id || s.folderKey,
                            class: "section-row"
                          }, [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("h2", null, _toDisplayString(s.name), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(['section-status', s.availableToAll ? 'section-status--public' : 'section-status--role'])
                                }, _toDisplayString(s.availableToAll ? 'Доступно всем' : 'По роли'), 3)
                              ]),
                              _createElementVNode("p", _hoisted_5, "Папка: " + _toDisplayString(s.folderKey), 1),
                              _createElementVNode("p", _hoisted_6, _toDisplayString(s.availableToAll ? 'Раздел виден всем пользователям' : _ctx.roleLabel(s.roleName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("label", _hoisted_8, [
                                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Доступно всем", -1)),
                                _createVNode(_component_ion_toggle, {
                                  modelValue: s.availableToAll,
                                  "onUpdate:modelValue": ($event: any) => ((s.availableToAll) = $event),
                                  mode: "ios",
                                  onIonChange: ($event: any) => (_ctx.saveSection(s))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonChange"])
                              ]),
                              _createVNode(_component_ion_item, {
                                lines: "none",
                                class: _normalizeClass(['section-role-select', { 'section-role-select--disabled': s.availableToAll }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Роль доступа",
                                    "label-placement": "stacked",
                                    modelValue: s.roleName,
                                    "onUpdate:modelValue": ($event: any) => ((s.roleName) = $event),
                                    interface: "popover",
                                    "interface-options": _ctx.roleSelectPopoverOptions,
                                    mode: "ios",
                                    placeholder: "Выберите роль",
                                    disabled: s.availableToAll,
                                    onIonChange: ($event: any) => (_ctx.saveSection(s))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: a.name,
                                          value: a.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onUpdate:modelValue", "interface-options", "disabled", "onIonChange"])
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createElementVNode("div", _hoisted_9, [
                                (s.id)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      fill: "clear",
                                      color: "medium",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.renameSection(s)),
                                      title: "Переименовать"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.pencilOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (s.id)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      fill: "clear",
                                      color: "danger",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.deleteSection(s)),
                                      title: "Удалить"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.trashOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, "Разделов пока нет."))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}